import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { InboundTripPAPSSignedForeignShippersDto } from 'dtos'
import { Formik } from 'formik'
import React from 'react'

interface SignedForeignShippersUploadDialogProps {
  initialValues: InboundTripPAPSSignedForeignShippersDto
  loading: boolean
  onClose: () => void
  onSave: (values: InboundTripPAPSSignedForeignShippersDto) => void
  open: boolean
}

export default function SignedForeignShippersUploadDialog({
  initialValues,
  loading,
  onClose,
  onSave,
  open
}: SignedForeignShippersUploadDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validateOnBlur
        validateOnChange
        // validationSchema={}
      >
        {({ errors, handleSubmit, isSubmitting, setFieldValue, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Signed Foreign Shippers</DialogTitle>

                  <Grid item xs={12}>
                    <input
                      accept='.jpeg,.jpg,.pdf,.png'
                      hidden
                      id='signedForeignShippersInput'
                      onChange={e => {
                        if (e.target.files && e.target.files.length > 0) {
                          setFieldValue('signedForeignShippersFile', e.target.files[0])
                        }
                      }}
                      type='file'
                    />

                    <Button
                      disabled={loading || isSubmitting}
                      onClick={() => {
                        document.getElementById('signedForeignShippersInput')?.click()
                      }}
                      variant='contained'
                    >
                      UPLOAD SIGNED FOREIGN SHIPPERS
                    </Button>

                    <Typography color='#808080' display='inline' variant='body2' sx={{ ml: 1 }}>
                      {values.signedForeignShippersFile?.name ?? values.signedForeignShippersFileName ?? 'No file uploaded'}
                    </Typography>

                    {errors.signedForeignShippersFile && (
                      <Typography color='error' variant='body2'>
                        {errors.signedForeignShippersFile}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} variant='text' color='inherit' onClick={onClose}>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
